import React, {useEffect, useRef} from 'react';
import {Outlet, useLocation, Location} from 'react-router-dom';
import {getCookie} from '@/utils/main';
import globalNavigation from '@/utils/global-navigation';
import SurveyHeader from '@/components/help/pc/my-inquiry/survey/surveyHeader';
import {useDeviceDetection} from '@/hooks/useDeviceDetection';
import {SoopLayerProvider} from '@soop-ui/soop-ui';
import {sendWebUvLog} from '@/utils/main';
import styles from './SurveyLayout.module.scss';

/**
 * webuv로그 필요할 거 같아서 layout.jsx에서 사용하는 코드 그대로 가져옴
 * @returns
 */
const useCallAULog = () => {
  const location = useLocation();
  const prevLocationRef = useRef<Location | null>(null);

  useEffect(() => {
    if (
      prevLocationRef?.current?.pathname === location.pathname &&
      prevLocationRef?.current?.search === location.search
    ) {
      return;
    }

    // webuv 전송
    const prevUrlForLog = `${window.location.origin}${prevLocationRef.current?.pathname ?? ''}${prevLocationRef.current?.search ?? ''}`;
    sendWebUvLog(prevUrlForLog);

    prevLocationRef.current = location;
  }, [location]);
  return null;
};

/**
 * 고객센터 답변 만족도 평가에서 사용되는 레이아웃
 * gnb는 로고만, fnb는 copyRight만 있는 형태
 */
const SurveyLayout = () => {
  useCallAULog();
  const isDark = getCookie('theme') === 'dark';
  const detectedDeviceType = useDeviceDetection('userAgent');
  const isMobile = detectedDeviceType === 'mobile';

  useEffect(() => {
    document.documentElement.setAttribute('responsive', 'true');
    return () => {
      document.documentElement.removeAttribute('responsive');
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document
        .querySelector('html')
        ?.setAttribute('dark', isDark ? 'true' : '');
      const $fnb = document.getElementById('soop-fnb');
      globalNavigation.init(null, null, $fnb, {
        showsFooterCopyrightOnly: true,
      });
    }
  }, [isDark]);

  useEffect(() => {
    if (isMobile) {
      document.documentElement.setAttribute('mobile', 'true');
    } else {
      document.documentElement.removeAttribute('mobile');
    }
  }, [isMobile]);

  return (
    <SoopLayerProvider>
      <div id='soop_wrap' className={styles.surveyLayout}>
        <SurveyHeader isDarkMode={isDark} />
        <Outlet />
        <div id='soop-fnb'></div>
      </div>
    </SoopLayerProvider>
  );
};

export default SurveyLayout;
